define(
    'utils/cookies',['jquery'],

    function ($) {
        function Cookies () {}

        /**
         * Get a cookie value
         *
         * @method get
         * @param key
         */
        Cookies.prototype.get = function (key) {
            var cookies = document.cookie.split(';'),
                result = null;

            $.each(cookies, function () {
                var s = this.trim(),
                    kv = s.split('=');

                if (kv[0] === key) {
                    result = kv[1];
                }
            });

            return result;
        };

        /**
         * Set a new cookie
         *
         * @method set
         * @param key
         * @param value
         * @param expiration Number of days for the cookie to be valid
         * @param path Path within site
         */
        Cookies.prototype.set = function (key, value, expiration, requiredPath) {
            var expires = '';
            var path = '';

            if (expiration !== undefined) {
                var d = new Date();

                d.setTime(d.getTime() + (expiration * 24 * 60 * 60 * 1000));
                expires = '; expires=' + d.toUTCString();
            }

            if (requiredPath !== undefined) {
                path = '; path=' + requiredPath;
            }

            document.cookie = key + '=' + value + expires + path;
        };

        /**
         * @method delete
         * @param key
         */
        Cookies.prototype.delete = function (key) {
            this.set(key, '', -1);
        };

        return new Cookies();
    }
);
